"use strict";

var _defineProperty = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$DEFINE_STICK;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFINE_STICKERS = exports.DEFINE_STICKER_NAMES = exports.StickerSizes = exports.StickerColors = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var styles = tslib_1.__importStar(require("./Sticker.style"));

exports.StickerColors = ['yellow', 'green', 'gray', 'blue', 'black'];
exports.StickerSizes = ['small', 'medium'];
var DEFINE_STICKER_NAMES;

(function (DEFINE_STICKER_NAMES) {
  DEFINE_STICKER_NAMES["BEST_PRICE"] = "BEST_PRICE";
  DEFINE_STICKER_NAMES["MEALS"] = "MEALS";
  DEFINE_STICKER_NAMES["IMMEDIATE"] = "IMMEDIATE";
  DEFINE_STICKER_NAMES["NEW"] = "NEW";
  DEFINE_STICKER_NAMES["VIDEO"] = "VIDEO";
})(DEFINE_STICKER_NAMES = exports.DEFINE_STICKER_NAMES || (exports.DEFINE_STICKER_NAMES = {}));

exports.DEFINE_STICKERS = (_exports$DEFINE_STICK = {}, _defineProperty(_exports$DEFINE_STICK, DEFINE_STICKER_NAMES.BEST_PRICE, {
  color: 'yellow',
  children: '최저가 보장제',
  name: DEFINE_STICKER_NAMES.BEST_PRICE
}), _defineProperty(_exports$DEFINE_STICK, DEFINE_STICKER_NAMES.MEALS, {
  color: 'gray',
  children: '무료 조식 · 석식',
  name: DEFINE_STICKER_NAMES.MEALS
}), _defineProperty(_exports$DEFINE_STICK, DEFINE_STICKER_NAMES.IMMEDIATE, {
  color: 'green',
  children: jsx_runtime_1.jsxs(react_1.Fragment, {
    children: [jsx_runtime_1.jsx(Icon_1.default, {
      name: "ic_instantbooking_7x12_green_700",
      alt: "immediate confirm"
    }, void 0), "\uC989\uC2DC\uD655\uC815"]
  }, void 0),
  name: DEFINE_STICKER_NAMES.IMMEDIATE
}), _defineProperty(_exports$DEFINE_STICK, DEFINE_STICKER_NAMES.NEW, {
  color: 'blue',
  children: 'NEW',
  name: DEFINE_STICKER_NAMES.NEW
}), _defineProperty(_exports$DEFINE_STICK, DEFINE_STICKER_NAMES.VIDEO, {
  color: 'black',
  children: jsx_runtime_1.jsxs(react_1.Fragment, {
    children: [jsx_runtime_1.jsx(Icon_1.default, {
      name: "ic_video_12x12_white",
      alt: "video"
    }, void 0), "\xA0\uC219\uC18C \uC601\uC0C1"]
  }, void 0),
  name: DEFINE_STICKER_NAMES.VIDEO
}), _exports$DEFINE_STICK);

function Sticker(_ref) {
  var className = _ref.className,
      size = _ref.size,
      color = _ref.color,
      children = _ref.children;
  return jsx_runtime_1.jsx("div", Object.assign({
    className: className,
    css: styles.wrapper(size, color)
  }, {
    children: children
  }), void 0);
}

exports.default = Sticker;